module.exports = __webpack_public_path__ + "static/media/ar.5261e632.svg";